var _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountryFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 41,
    viewBox: "0 0 152 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.2969,
    r: 19,
    fill: "#D9D9D9",
    stroke: "#FEFEFF",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6358_80456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 38.2969C29.9411 38.2969 38 30.238 38 20.2969C38 10.3557 29.9411 2.29688 20 2.29688C10.0589 2.29688 2 10.3557 2 20.2969C2 30.238 10.0589 38.2969 20 38.2969Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 20.3022C2 28.0417 6.88475 34.6394 13.7392 37.1827V3.42188C6.88475 5.96508 2 12.5629 2 20.3022Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0009 20.3022C38.0009 12.5629 33.1161 5.96508 26.2617 3.42188V37.1828C33.1161 34.6394 38.0009 28.0417 38.0009 20.3022Z",
    fill: "#6DA544"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 20.2969,
    r: 19,
    fill: "#D9D9D9",
    stroke: "#FEFEFF",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6358_80456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 38.2969C57.9411 38.2969 66 30.238 66 20.2969C66 10.3557 57.9411 2.29688 48 2.29688C38.0589 2.29688 30 10.3557 30 20.2969C30 30.238 38.0589 38.2969 48 38.2969Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2188 20.2972H66.0013C66.0013 18.6726 65.7848 17.0987 65.3812 15.6016H47.2188V20.2972Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2188 10.9066H63.3594C62.2575 9.10859 60.8487 7.51931 59.206 6.21094H47.2188V10.9066Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0016 38.3037C52.2378 38.3037 56.1315 36.8395 59.2063 34.3906H36.7969C39.8716 36.8395 43.7653 38.3037 48.0016 38.3037Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6429 29.6879H63.3591C64.2437 28.2444 64.9297 26.6666 65.3809 24.9922H30.6211C31.0723 26.6666 31.7583 28.2444 32.6429 29.6879Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3379 5.10783H39.9783L38.4525 6.2163L39.0353 8.00991L37.5096 6.90143L35.9839 8.00991L36.4873 6.46043C35.1439 7.57945 33.9665 8.8905 32.9962 10.3513H33.5217L32.5505 11.0569C32.3992 11.3093 32.2541 11.5657 32.115 11.826L32.5788 13.2534L31.7135 12.6247C31.4984 13.0804 31.3017 13.5464 31.1249 14.022L31.6358 15.5948H33.5217L31.996 16.7033L32.5788 18.4969L31.0531 17.3884L30.1391 18.0524C30.0477 18.7878 30 19.5367 30 20.2969H48C48 10.3558 48 9.18384 48 2.29688C44.4442 2.29688 41.1294 3.32836 38.3379 5.10783ZM39.0353 18.4969L37.5096 17.3884L35.9839 18.4969L36.5667 16.7033L35.0409 15.5948H36.9268L37.5096 13.8012L38.0923 15.5948H39.9783L38.4525 16.7033L39.0353 18.4969ZM38.4525 11.4598L39.0353 13.2534L37.5096 12.1449L35.9839 13.2534L36.5667 11.4598L35.0409 10.3513H36.9268L37.5096 8.55771L38.0923 10.3513H39.9783L38.4525 11.4598ZM45.4918 18.4969L43.9661 17.3884L42.4404 18.4969L43.0232 16.7033L41.4974 15.5948H43.3834L43.9661 13.8012L44.5489 15.5948H46.4348L44.909 16.7033L45.4918 18.4969ZM44.909 11.4598L45.4918 13.2534L43.9661 12.1449L42.4404 13.2534L43.0232 11.4598L41.4974 10.3513H43.3834L43.9661 8.55771L44.5489 10.3513H46.4348L44.909 11.4598ZM44.909 6.2163L45.4918 8.00991L43.9661 6.90143L42.4404 8.00991L43.0232 6.2163L41.4974 5.10783H43.3834L43.9661 3.31423L44.5489 5.10783H46.4348L44.909 6.2163Z",
    fill: "#0052B4"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 20.2969,
    r: 19,
    fill: "#D9D9D9",
    stroke: "#FEFEFF",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6358_80456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 38.2969C85.9411 38.2969 94 30.238 94 20.2969C94 10.3557 85.9411 2.29688 76 2.29688C66.0589 2.29688 58 10.3557 58 20.2969C58 30.238 66.0589 38.2969 76 38.2969Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7219 9.34375C60.308 11.1833 59.2419 13.3036 58.6211 15.607H67.9852L61.7219 9.34375Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3815 15.6069C92.7607 13.3036 91.6945 11.1833 90.2807 9.34375L84.0176 15.6069H93.3815Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6211 25C59.242 27.3033 60.3081 29.4236 61.7219 31.2631L67.985 25H58.6211Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9604 6.0228C85.1208 4.60888 83.0006 3.54273 80.6973 2.92188V12.2859L86.9604 6.0228Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.043 34.5755C66.8826 35.9894 69.0028 37.0556 71.3061 37.6764V28.3125L65.043 34.5755Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3061 2.92188C69.0028 3.54273 66.8825 4.60888 65.043 6.02273L71.3061 12.2858V2.92188Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6973 37.6764C83.0006 37.0556 85.1208 35.9894 86.9604 34.5756L80.6973 28.3125V37.6764Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0176 25L90.2807 31.2632C91.6945 29.4236 92.7607 27.3033 93.3815 25H84.0176Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8476 17.9491H78.3479H78.3479V2.44924C77.5793 2.34919 76.7957 2.29688 76 2.29688C75.2041 2.29688 74.4207 2.34919 73.6522 2.44924V17.9489V17.949H58.1524C58.0523 18.7176 58 19.5011 58 20.2969C58 21.0927 58.0523 21.8762 58.1524 22.6447H73.6521H73.6521V38.1445C74.4207 38.2446 75.2041 38.2969 76 38.2969C76.7957 38.2969 77.5793 38.2446 78.3478 38.1445V22.6448V22.6448H93.8476C93.9477 21.8762 94 21.0927 94 20.2969C94 19.5011 93.9477 18.7176 93.8476 17.9491Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6953 24.9923L88.7275 33.0245C89.097 32.6552 89.4494 32.2691 89.7856 31.8689L82.9089 24.9922H80.6953V24.9923Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3038 24.9922H71.3036L63.2715 33.0243C63.6408 33.3938 64.0269 33.7462 64.4271 34.0824L71.3038 27.2056V24.9922Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3051 15.6027V15.6026L63.2729 7.57031C62.9035 7.93959 62.5511 8.32568 62.2148 8.7259L69.0916 15.6027H71.3051V15.6027Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6953 15.606L88.7276 7.57362C88.3583 7.2042 87.9722 6.85179 87.572 6.51562L80.6953 13.3924V15.606Z",
    fill: "#D80027"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 20.2969,
    r: 19,
    fill: "#D9D9D9",
    stroke: "#FEFEFF",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_6358_80456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 38.2969C113.941 38.2969 122 30.238 122 20.2969C122 10.3558 113.941 2.29688 104 2.29688C94.0589 2.29688 86 10.3558 86 20.2969C86 30.238 94.0589 38.2969 104 38.2969Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 20.292C122 13.1557 117.847 6.98962 111.826 4.07812V36.5059C117.847 33.5945 122 27.4283 122 20.292Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 20.292C86 27.4283 90.153 33.5945 96.1739 36.506V4.07812C90.153 6.98962 86 13.1557 86 20.292Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.13 22.6386L110.26 21.0733L108.695 20.2908V18.7255L105.564 20.2908L107.13 17.1603H105.564L103.999 14.8125L102.434 17.1603H100.869L102.434 20.2908L99.3034 18.7255V20.2908L97.7383 21.0733L100.869 22.6386L100.086 24.2038H103.217V26.5516H104.782V24.2038H107.912L107.13 22.6386Z",
    fill: "#D80027"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 20.2969,
    r: 19,
    fill: "#22428F",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.162 25.2969H120.938V18.2409H119.366V17.1849H122.162V25.2969ZM126.423 25.4169C124.839 25.4169 123.627 24.3849 123.567 22.9449H124.779C124.863 23.8089 125.523 24.3249 126.423 24.3249C127.539 24.3249 128.091 23.6289 128.091 22.7049C128.091 21.8649 127.491 21.1329 126.411 21.1329C125.691 21.1329 125.151 21.4329 124.815 22.0209L123.831 21.7089L124.551 17.1849H128.883V18.2649H125.427L125.067 20.6049C125.523 20.2449 126.039 20.0769 126.591 20.0769C128.379 20.0769 129.351 21.3249 129.351 22.7049C129.351 24.1569 128.307 25.4169 126.423 25.4169ZM130.356 21.2529C130.356 18.5649 131.424 17.0649 133.344 17.0649C135.264 17.0649 136.344 18.5649 136.344 21.2529C136.344 23.9409 135.288 25.4169 133.344 25.4169C131.4 25.4169 130.356 23.9409 130.356 21.2529ZM131.604 21.2529C131.604 23.2569 132.204 24.3249 133.344 24.3249C134.484 24.3249 135.096 23.2689 135.096 21.2529C135.096 19.2249 134.484 18.1569 133.344 18.1569C132.228 18.1569 131.604 19.2249 131.604 21.2529ZM141.452 24.2049H140.324V21.7569H137.888V20.7129H140.324V18.2889H141.452V20.7129H143.888V21.7569H141.452V24.2049Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6358_80456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(2 2.29688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6358_80456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(30 2.29688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6358_80456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(58 2.29688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_6358_80456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(86 2.29688)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryFlag);
export default __webpack_public_path__ + "static/media/country-flag.a589e0e4e540772ece7f8a9471b4fb9b.svg";
export { ForwardRef as ReactComponent };